import { collectElementsDeepShadow } from './applyScopedControlbarHoverBackground';
import {
  RTK_DEBUGGER_SHELL_SHADOW_CSS,
  RTK_DEBUGGER_TAB_PANEL_SHADOW_CSS,
  RTK_DEBUGGER_DIALOG_SHADOW_CSS,
} from '../overrides/rtk-debugger-layout.shadow-export';

const SHELL_STYLE_ID = 'wbs-rtk-debugger-shell-layout';
const TAB_PANEL_STYLE_ID = 'wbs-rtk-debugger-tab-panel-layout';
const DIALOG_STYLE_ID = 'wbs-rtk-dialog-troubleshooting-width';

/** Kit tab hosts share `overflow: hidden` on `:host`; inject fixes into each shadow. */
const TAB_PANEL_TAGS = [
  'rtk-debugger-audio',
  'rtk-debugger-video',
  'rtk-debugger-screenshare',
  'rtk-debugger-system',
];

/** @param {ShadowRoot | null | undefined} sr */
function injectIntoShadow(sr, styleId, cssText) {
  if (!sr || sr.getElementById(styleId)) return false;
  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = cssText;
  sr.appendChild(style);
  return true;
}

/**
 * Appends layout overrides into `rtk-debugger` and each tab panel shadow tree under the meeting host.
 *
 * @param {HTMLElement | null} meetingHostEl outer `<rtk-meeting>`
 */
export function injectRtkDebuggerLayoutOverrides(meetingHostEl) {
  if (!meetingHostEl?.shadowRoot || typeof document === 'undefined') {
    return;
  }

  const root = meetingHostEl.shadowRoot;

  const dialogs = collectElementsDeepShadow(root, 'rtk-dialog');
  for (const dlg of dialogs) {
    if (!dlg.querySelector('rtk-debugger')) continue;
    const dsr = dlg.shadowRoot;
    if (!dsr) continue;
    injectIntoShadow(dsr, DIALOG_STYLE_ID, RTK_DEBUGGER_DIALOG_SHADOW_CSS);
  }

  const debuggers = collectElementsDeepShadow(root, 'rtk-debugger');
  for (const host of debuggers) {
    const sr = host.shadowRoot;
    if (!sr) continue;
    injectIntoShadow(sr, SHELL_STYLE_ID, RTK_DEBUGGER_SHELL_SHADOW_CSS);
  }

  for (const tag of TAB_PANEL_TAGS) {
    const panels = collectElementsDeepShadow(root, tag);
    for (const panel of panels) {
      const psr = panel.shadowRoot;
      if (!psr) continue;
      injectIntoShadow(psr, TAB_PANEL_STYLE_ID, RTK_DEBUGGER_TAB_PANEL_SHADOW_CSS);
    }
  }
}
